import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Check, Sparkles, Zap, Rocket } from 'lucide-react';
import CheckoutButton from '../components/Payment/CheckoutButton';

const Pricing = () => {

// In Pricing.jsx, clearly show what's locked for free users
const plans = [
  {
    id: 'free',
    name: 'Free',
    price: '$0',
    period: 'forever',
    features: [
      '1 Resume',
      'Basic Templates',
      'Online Preview',
      'TXT Export',
      '❌ PDF Download (Premium)',
      '❌ Cover Letter (Premium)'
    ],
    cta: 'Get Started',
    popular: false,
  },
  {
    id: 'weekly',
    name: 'Weekly',
    price: '$2',
    period: 'per week',
    features: [
      'Unlimited Resumes',
      'All Templates (70+)',
      'PDF Download',
      'Cover Letter',
      'TXT Export',
      'All Industries'
    ],
    cta: 'Start Weekly',
    popular: true,
  },
  {
    id: 'monthly',
    name: 'Monthly',
    price: '$5',
    period: 'per month',
    features: [
      'Unlimited Resumes',
      'All Templates (70+)',
      'PDF Download',
      'Cover Letter',
      'TXT Export',
      'All Industries',
      'Cancel Anytime'
    ],
    cta: 'Subscribe Monthly',
    popular: false,
  },
];
return (
    <Container className="py-5" style={{ paddingTop: '80px' }}>
      {/* Header */}
      <div className="text-center mb-5">
        <h2 className="display-5 fw-bold text-dark">Simple, Transparent Pricing</h2>
        <p className="text-muted">Start free, upgrade when you need more</p>
      </div>

      {/* Pricing Cards - Bootstrap Grid */}
      <Row className="g-4 justify-content-center">
        {plans.map((plan) => (
          <Col key={plan.id} xs={12} md={4}>
            <Card 
              className={`h-100 text-center p-4 ${
                plan.popular 
                  ? 'border-primary border-2 shadow-lg position-relative' 
                  : 'border border-secondary-subtle shadow-sm'
              }`}
            >
              {plan.popular && (
                <div className="position-absolute top-0 start-50 translate-middle-x bg-primary text-white px-3 py-1 rounded-pill" style={{ fontSize: '0.7rem', fontWeight: 'bold' }}>
                  Most Popular
                </div>
              )}

              <Card.Body className="d-flex flex-column">
                <Card.Title className="h5 fw-bold text-dark">{plan.name}</Card.Title>
                
                <div className="mt-2">
                  <span className="display-6 fw-bold text-dark">{plan.price}</span>
                  <span className="text-muted">/{plan.period}</span>
                </div>

                <ul className="list-unstyled mt-4 text-start">
                  {plan.features.map((feature) => (
                    <li key={feature} className="d-flex align-items-center gap-2 text-sm text-secondary py-1">
                      <Check className="text-success flex-shrink-0" size={18} />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-auto pt-3">
                  {plan.id === 'free' ? (
                    <Link
                      to="/signup"
                      className={`btn w-100 ${
                        plan.popular
                          ? 'btn-primary'
                          : 'btn-outline-secondary'
                      }`}
                    >
                      {plan.cta}
                    </Link>
                  ) : (
                    <CheckoutButton
                      planId={plan.id}
                      buttonText={plan.cta}
                      className={`btn w-100 text-white ${
                        plan.popular
                          ? 'btn-primary'
                          : 'btn-dark'
                      }`}
                    />
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <p className="text-center text-muted mt-5 small">
        UPI and all major cards accepted. Cancel anytime.
      </p>
    </Container>
  );
};

export default Pricing;